import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'reactstrap';

import './InputWithTextBox.scss';

export default class InputWithTextBox extends Component {
  render() {
    const {
      value,
      placeholder,
      onChange,
      onKeyPress,
      template,
      onClick,
      disabled,
      id,
      maxLength,
      text,
    } = this.props;

    return (
      <div className={`InputWithTextBox${template ? ` template-${template}` : ''}`}>
        <div className={'group-input'}>
          <Input
            id={id}
            placeholder={placeholder}
            value={value}
            onChange={event => onChange(event)}
            onKeyPress={onKeyPress}
            onClick={onClick}
            disabled={disabled}
            maxLength={maxLength}
          />
          <span className="text">{text}</span>
        </div>
      </div>
    );
  }
}

InputWithTextBox.propTypes = {
  'id': PropTypes.string,
  'value': PropTypes.any,
  'icon': PropTypes.string,
  'placeholder': PropTypes.string,
  'type': PropTypes.string,
  'onChange': PropTypes.func.isRequired,
  'onKeyPress': PropTypes.func,
  'template': PropTypes.string,
  'onClick': PropTypes.func,
  'disabled': PropTypes.bool,
  'maxLength': PropTypes.string,
  'text': PropTypes.string,
};
